import { Model, attr } from "redux-orm";

class MultipleOutputCustomShape extends Model {
  static modelName = "MultipleOutputCustomShape";

  static get fields() {
    return {
      id: attr(),
      cut_file: attr(),
      front_image: attr(),
      original_image: attr(),
    };
  }

  static types = {
    create: (payload) => ({
      type: "NEW_CUSTOM_SHAPE/CREATE",
      payload,
    }),
    processImage: (payload) => ({
      type: "NEW_CUSTOM_SHAPE/POST",
      payload,
    }),
    getProcessedImage: (payload) => ({
      type: "NEW_CUSTOM_SHAPE/GET",
      payload,
    }),
    saveCustomDesign: (payload) => ({
      type: "NEW_CUSTOM_SHAPE/SAVE_DESIGN",
      payload,
    }),
  };

  static reducer(action, MultipleOutputCustomShape) {
    switch (action.type) {
      case this.types.create().type:
        MultipleOutputCustomShape.create({ ...action.payload });
        break;
    }
  }

  static selectors = {
    getCustomShapebyId: (state, id) => state.MultipleOutputCustomShape.itemsById[id] || {},
    getCustomShapeListByDesign: (state, designId) =>
      Object.values(state.MultipleOutputCustomShape.itemsById)?.filter(
        (item) => designId == item?.design_id && !!item?.front_image
      ) || [],

    getCustomShapeList: (state) =>
      Object.values(state.MultipleOutputCustomShape.itemsById)?.filter(
        (item) => !!item?.front_image
      ) || [],
  };
}

export default MultipleOutputCustomShape;
